import TextButton from 'LuxKit/Button/TextButton'
import LineHeartIcon from 'LuxKit/Icons/line/LineHeartIcon'
import SolidHeartIcon from 'LuxKit/Icons/solid/SolidHeartIcon'
import type { ComponentProps } from 'react'
import { useCallback } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { useAppSelector } from 'hooks/reduxHooks'
import { selectLoggedIn } from 'selectors/accountSelectors'
import usePendingLoginHandler from 'hooks/usePendingLoginHandler'
import useNavigateTo from 'hooks/useNavigateTo'
import { useWishlistIndex } from 'wishlists/hooks'
import config from 'constants/config'

const MenuItem = styled.div`
  position: relative;
`

type InheritedTextButtonProps = Pick<ComponentProps<typeof TextButton>, 'size'>

interface Props extends InheritedTextButtonProps {}

function NavigationHeaderTripsMenu(props: Props) {
  if (!config.ENABLE_TRIP_PLANNER) return null

  return <NavigationHeaderTripsMenuInner {...props} />
}

function NavigationHeaderTripsMenuInner(props: Props) {
  const { size } = props
  const intl = useIntl()
  const { data: wishlistData } = useWishlistIndex()
  const isLoggedIn = useAppSelector(selectLoggedIn)
  const navigateTo = useNavigateTo()

  const navigateToWishlists = useCallback(() => {
    navigateTo('/wishlists')
  }, [navigateTo])

  const handleWishlistClick = usePendingLoginHandler(navigateToWishlists, 'wishlistLogin')

  const hasSavedItems = Boolean(
    wishlistData?.wishlists.find((wishlist) => wishlist.isDefault)?.itemCount,
  )

  const wishlistText = intl.formatMessage({
    id: '8tn_OvJmXrdKVNnw4EQO',
    defaultMessage: 'Wishlist',
    description: 'Wishlist navigation button text in the website header',
  })

  return (
    <MenuItem>
      <TextButton
        kind="tertiary"
        variant="dark"
        size={size}
        startIcon={hasSavedItems ? <SolidHeartIcon colour="favourite" /> : <LineHeartIcon />}
        {...(isLoggedIn ? { to: '/wishlists' } : { onClick: handleWishlistClick })}
      >
        {wishlistText}
      </TextButton>
    </MenuItem>
  )
}

export default NavigationHeaderTripsMenu
